import React from 'react';
import {
  Button,
  Modal,
  Tooltip,
  Popover,
  OverlayTrigger,
  Tab,
  Row,
  Col,
  Nav,
  NavItem,
} from 'react-bootstrap';
import ChartModal from './ChartModal';
import { injectIntl } from 'react-intl';
import { observer, inject } from 'mobx-react';

@injectIntl
@inject('keepStore')
@observer
export default class Keep extends React.Component {
  constructor(props) {
    super(props);

    this.openModal = this.openModal.bind(this);
    this.handleHide = this.handleHide.bind(this);

    this.state = { show: false, active: -1, loaded: false };
  }

  openModal(index) {
    if (this.state.active == -1) {
      this.setState({
        show: true,
        active: index,
      });
    }
  }

  handleHide() {
    this.setState({
      show: false,
      active: -1,
    });
  }

  render() {
    const { intl } = this.props;
    const { keepStore } = this.props;

    if (!keepStore.loaded) {
      return (
        <div className="main-loader">
          <div className="loader-lg"></div>
        </div>
      );
    }

    let plots = ['daily', 'weekly', 'monthly'];
    let rates = ['crr', 'ccr', 'cl'];

    return (
      <div>
        <h2 className={'bold text-center'}>
          {intl.formatMessage({ id: 'tendencies_title' })}
        </h2>
        <Row>
          <h3 className={'text-center'}>
            {intl.formatMessage({ id: 'activity_title' })}
          </h3>
        </Row>
        <Row>
          {plots.map((item, i) => {
            return (
              <Col xs={4} key={i}>
                <ChartModal
                  openModal={() => {
                    this.openModal(item + ' active');
                  }}
                  active={this.state.active == item + ' active'}
                  showSecondPlot={true}
                  handleHide={() => {
                    this.handleHide();
                  }}
                  closeModal={() => {
                    this.setState({ show: false, active: -1 });
                  }}
                  entry={item}
                  label={intl.formatMessage({
                    id: item + '_active_startups_label',
                  })}
                  title={intl.formatMessage({
                    id: item + '_active_startups_title',
                  })}
                  data={keepStore.dataStartups}
                />
              </Col>
            );
          })}
        </Row>

        <Row>
          <h3 className={'text-center'}>
            {intl.formatMessage({ id: 'stickiness_title' })}
          </h3>
        </Row>

        <Row>
          {plots.map((item, i) => {
            return (
              <Col xs={4} key={i}>
                <ChartModal
                  openModal={() => {
                    this.openModal(item + ' stickiness');
                  }}
                  active={this.state.active == item + ' stickiness'}
                  showSecondPlot={true}
                  handleHide={() => {
                    this.handleHide();
                  }}
                  container={this}
                  closeModal={() => {
                    this.setState({ show: false, active: -1 });
                  }}
                  entry={item}
                  label={intl.formatMessage({ id: item + '_stickiness_label' })}
                  title={intl.formatMessage({ id: item + '_stickiness_title' })}
                  data={keepStore.dataStickiness}
                />
              </Col>
            );
          })}
        </Row>

        <Row>
          <h3 className={'text-center'}>
            {intl.formatMessage({ id: 'customers_title' })}
          </h3>
        </Row>
        <Row>
          {rates.map((item, i) => {
            return (
              <Col xs={4} key={i}>
                <ChartModal
                  openModal={() => {
                    this.openModal(item);
                  }}
                  active={this.state.active == item}
                  showSecondPlot={true}
                  handleHide={() => {
                    this.handleHide();
                  }}
                  container={this}
                  closeModal={() => {
                    this.setState({ show: false, active: -1 });
                  }}
                  entry={item}
                  label={intl.formatMessage({ id: item + '_label' })}
                  title={intl.formatMessage({ id: item + '_title' })}
                  data={keepStore.dataRates}
                />
              </Col>
            );
          })}
        </Row>
      </div>
    );
  }
}
